<script lang="ts" setup>

import {Source} from "@/domain/type/source.type.ts";
import CreateForm from "@/components/Create/CreateForm.vue";
import {onBeforeMount} from "vue";
import {useCompanyCreateStore} from "@/stores/create.store.ts";

const props = defineProps<{
  target: Source,
  type: string
}>();

const store = useCompanyCreateStore()

onBeforeMount(() => {
  store.currentTarget = props.target;
})
</script>

<template>
  <div class="d-flex justify-center pt-15">
    <create-form :target="target" :type="type"/>
  </div>
</template>

<style scoped>

</style>
